import React from 'react';
import useWindowSize from '@shared/hooks/useWindowsSize';
import { Fab } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';

import { useSelector } from 'react-redux';

const timestamp = new Date().getTime();

const urlFolletoOceanFestGIT =
  'https://git-static-assets.s3.us-east-1.amazonaws.com/PDFs/Tarifario+Ocean+Fest+-+GIT.pdf#toolbar=0&navpanes=0' +
  `?${timestamp}`;
const urlFolletoOceanFestTDH =
  'https://git-static-assets.s3.us-east-1.amazonaws.com/PDFs/Tarifario+Ocean+Fest+-+Viajes+TDH.pdf#toolbar=0&navpanes=0' +
  `?${timestamp}`;

export default () => {
  const screenSize = useWindowSize();
  const { id } = useSelector(store => store.pageConfiguration);

  const url = id == 1 ? urlFolletoOceanFestTDH : urlFolletoOceanFestGIT;
  const fileName =
    id == 1 ? 'Tarifario_OceanFest_TDH.pdf' : 'Tarifario_OceanFest_GIT.pdf';

  const handleDownload = async () => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      alert('Hubo un problema al intentar descargar el archivo.');
    }
  };

  return (
    <div
      style={{
        width: '100%',
        height: screenSize.width < 840 ? '1300px' : '2520px',
        margin: 'auto',
        overflow: 'hidden',
      }}
    >
      <iframe src={url} width="100%" height="100%"></iframe>
      <Fab
        size="medium"
        color="primary"
        aria-label="Descargar"
        onClick={handleDownload}
        style={{
          position: 'fixed',
          right: 0,
          bottom: 0,
          margin: '0 20px 20px 0',
        }}
      >
        <GetAppIcon />
      </Fab>
    </div>
  );
};
